<template>
<div class="game row position-relative">
	<div v-if="!hidden && item.status=='reserved'" class="reserved-text position-absolute text-uppercase page-title start-50 top-50 w-auto z-1">Rezervat</div>
	<div class="col-12 mb-3" v-if="!hidden" :class="{ 'opacity-25': item.status=='reserved' }">
	    <div class="card shadow h-100 p-0 p-md-2 position-relative" :class="'border-left-'+item.condition+' border-right-'+checkDiscount(item)">
	        <div class="card-body pt-2 pb-0" :class="{'pb-2': ['other','bundle'].includes(item.type)}">
	            <div class="row align-items-center h-100">
	                <a :href="game_link" @click.prevent="clickGame(item)" class="cover col-1 mr-2 h-100 d-mobile-none" :style="{ backgroundImage: 'url(\''+item.thumbnail+'\')' }" :class="{'cursor-pointer': !['other','bundle'].includes(item.type) || item.thumbnail, 'no-hover': item.type=='bundle'}">
	                	<div v-if="item.type=='bundle'" :class="'text-center text-'+item.condition"><i class="fa-solid fa-box fs-4rem mt-2"></i></div>
	                </a>
	                <div class="col pl-0 pl-md-2 ml-md-1">
	                    <div class="cover bg-md-none pl-5 pl-md-1 ml-n1 ml-md-0" :style="{ backgroundImage: 'linear-gradient(to right, transparent 0%, transparent 6%, #FFFFFF 15%, #FFFFFF 100%), url(\''+item.thumbnail+'\')' }">
	                        <div class="row no-gutters">
	                            <div class="col-4 mr-2">
	                                <div class="shadow-white text-xs font-weight-bold text-uppercase mb-1 d-inline" :class="'text-'+item.condition">{{showCondition(item.condition)}}</div>
	                            </div>
	                            <div v-if="item.type!='other'" class="col text-right">
                                    <template v-if="item.type!='bundle'">
		                                <a v-if="item.shop" :href="'https://howtoplay.ro/oferte-boardgames/bgg-'+item.id" target="_blank" class="text-xs mb-1" :class="{ 'text-muted': !item.shop.stock }" data-toggle="tooltip" data-placement="top" :title="item.shop.name">
		                                    <b v-if="item.shop.stock">NOU</b> 
		                                    <span v-else>În trecut</span>
		                                    de la <b>{{ item.shop.price }} RON</b> <span class="d-mobile-none ml-1">la <b>{{ item.shop.name }}</b></span> <span :class="'text-'+item.condition"><i class="ml-1 fa-solid fa-arrow-up-right-from-square d-mobile-none"></i></span>
		                                </a>
		                                <span v-else class="text-xs mb-1 text-muted">Nu există în magazine</span>
		                            </template>
		                            <template v-else>
                                        <span v-if="bundle_shop().stock" class="text-xs mb-1" v-tooltip="{ content: checkException(item)?'Conține jocuri indisponibile în magazine':'', trigger: 'hover click'}">
                                            <b>NOU</b> de la 
                                            <b>{{ bundle_shop().price }} RON</b> 
                                            <span v-if="bundle_shop().exception">*</span>
                                        </span>
                                        <span v-else class="text-xs mb-1 text-muted">Nu există în magazine</span>
                                    </template>    
	                            </div>
	                        </div>
	                        <div class="row no-gutters mb-1">
	                            <div class="col mr-2">
	                                <a :href="game_link" @click.prevent="clickGame(item)" class="h4 mb-0 font-weight-bold text-black-800 fs-mobile-5 shadow-white" :class="{'name': !['other','bundle'].includes(item.type) || item.thumbnail, 'no-hover': item.type=='bundle'}">
	                                    {{ item.name }} 
	                                    <span v-if="!['other','bundle'].includes(item.type)" :class="'text-'+item.condition"><i class="h6 fa-solid fa-arrow-up-right-from-square d-mobile-none"></i></span>
	                                    <span v-else v-show="item.thumbnail" :class="'text-'+item.condition"><i class="h6 fa-solid fa-image d-mobile-none"></i></span>
	                                </a>
	                                <div v-if="!['other','bundle'].includes(item.type)" class="shadow-white stats text-xs text-md-s">
	                                    <span :class="'text-'+item.condition"><i class="fa-solid fa-star"></i></span> <strong>{{ item.rating }}</strong>
	                                    <span :class="'text-'+item.condition"><i class="fa-solid fa-users ml-2"></i></span> {{ item.minplayers }}{{ (parseInt(item.maxplayers) > parseInt(item.minplayers)) ? " - "+item.maxplayers : "" }}
	                                    <span :class="'text-'+item.condition"><i class="fa-solid fa-clock ml-2"></i></span> {{ item.minplaytime }}'{{ (parseInt(item.maxplaytime) > parseInt(item.minplaytime)) ? " - "+item.maxplaytime+"'" : "" }}
	                                    <span :class="'text-'+item.condition"><i class="fa-solid fa-weight-hanging ml-2"></i></span> {{ item.weight }}
	                                </div>
	                            </div>
	                            <div v-if="item.price" class="col-3 text-right">
	                                <h4 class="text-right fs-mobile-5 fs-md-4 text-black">
	                                    <strong class="">{{item.price}} <span class="fs-mobile-6 fs-md-5 fw-bold">RON</span></strong>
	                                </h4>
	                            </div>
	                        </div>
	                    </div>
	                    <div class="row no-gutters ml-0 ml-md-n2">
	                        <div class="col-9">
	                        	<div v-show="item.bgg_data" class="description">
		                            <p class="mechanics collapse mb-1 text-xs" :id="'collapse'+item.id" aria-expanded="false">
		                                <span v-for="mechanic in item.mechanics" class="mechanic d-inline-block pl-1 pr-1 mr-1 mb-1 text-white" :class="'background-'+item.condition">{{ mechanic }}</span>
		                            </p>
		                            <p v-html="item.description" class="collapse m-0 hide" :id="'collapse'+item.id" aria-expanded="false"></p>
		                            <a role="button" class="collapsed text-s align-top" :class="'text-'+item.condition" data-bs-toggle="collapse" :href="'#collapse'+item.id" aria-expanded="false" aria-controls="collapse"></a> 
		                        </div> 
		                        <div v-if="['other','bundle'].includes(item.type) && item.notes" class="description text-mobile-s mt-n2">
		                            <p class="m-0">{{item.notes}}</p>
		                        </div>
	                        </div>
	                        <div class="col-3 text-right" :class="{'min-height-50px': getDiscount(item)}">
                                <h3 v-if="getDiscount(item)" class="text-white mr-n2 mr-md-n3 rounded-top-left text-right d-inline" :class="discount_label_class" v-tooltip="{ content: checkException(item)?'Conține jocuri indisponibile în magazine':'', trigger: 'hover click'}">
                                    {{ getDiscount(item) }}
                                </h3>
	                        </div>
	                    </div>

                        <div v-if="item.type=='bundle' && item.games.length && !hidden" class="bundle-items no-gutters mt-md-3 mb-3 ml-0 ml-md-n7 ml-lg-n8 ml-xl-n9 ml-xxl-n10 mr-n2 bg-light border px-2 pt-2">
                            <div v-for="(subitem, j) in item.games" :key="item.games[j].id" :bgg-id="item.games[j].id" class="item">
                                <view-item :item="subitem" :index="j" :parent-id="item.id" :filters="filters"></view-item>
                            </div>
                        </div>
	                </div>
	            </div>
	        </div>
	        <div v-if="!['other', 'bundle'].includes(item.type) && (item.type=='boardgameexpansion' || item.notes)" class="row no-gutters mb-1">
	            <div class="col px-3">
	                <div class="input-group mb-0 text-gray align-left bg-light border px-2 p-0 p-md-2 px-md-3 d-block">
	                    <div class="float-start">
	                        <span class="text-xs text-md-s font-weight-bold mr-1">Notă:</span>
	                    </div>
	                    <div v-if="item.type=='boardgameexpansion'" class="float-start">
	                        <span class="pr-2 text-xs text-md-s">
	                            Extensie pentru 
	                            <a class="mb-0 ml-0 font-weight-bold" :href="'https://boardgamegeek.com/boardgame/'+item.main_game.id" target="_blank">{{ item.main_game.name }} <i :class="'text-'+item.condition" class="fa-solid fa-arrow-up-right-from-square d-mobile-none"></i></a>
	                        </span>
	                    </div>
	                    <span v-if="item.notes" class="text-xs text-md-s">{{item.notes}}</span>
	                    <span v-else>&nbsp;</span>
	                </div>
	            </div>
	        </div>
	    </div>
	</div>
</div>
</template>
<script>
    import Vue from "vue";
    import HelperItemMixin from "../mixins/HelperItemMixin";
    import Popper from 'vue-popperjs';
    import VTooltip from 'v-tooltip'

    Vue.use(VTooltip);

    export default {
        name: "ViewItem",
        components: { 'popper': Popper },
        mixins: [HelperItemMixin],
        props: ['item', 'index', 'parentId', 'filters'],
        computed: { 
            discount_label_class: function() {
                return 'background-'+this.checkDiscount(this.item)+' '+(this.item.type=='bundle'?'py-2 pl-2 pr-3 pr-md-4':'p-2');
            },
            game_link: function() {
                if(!['other','bundle'].includes(this.item.type)) {
                    return 'https://boardgamegeek.com/boardgame/'+this.item.id;
                } else if(this.item.type == 'other' && this.item.thumbnail) {
                	return this.item.thumbnail;
                }
                return '';
            },
            hidden: function() {
            	if(this.item.status=='hidden') return true;
            	if(!this.parentId && this.filters.search!= '' && this.item.name.normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase().search(this.filters.search.toLowerCase()) == -1) return true;
            	return false;
            }
        },
        data() {
            return {}
        },
        mounted() {},
        methods: {
            clickGame: function(item) { this.parentId ? this.$parent.$parent.clickGame(item): this.$parent.clickGame(item); }
        }
    };
</script>